module.exports = __webpack_public_path__ + "static/media/2.3f82c71e.jpg";